import { Injectable } from '@angular/core';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { UniversalService } from './universal.service';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {

  bufferTimeoutForFetchingData = 200;
  LOCAL_DB = {};

  constructor(public universalService:UniversalService) { }

  getBufferDataForNextPage(pageNo){
    if(this.LOCAL_DB[pageNo] && this.LOCAL_DB[pageNo] != 'viewed'){
      return this.LOCAL_DB[pageNo];
    }else{
      return [];
    }
  }

  setBufferDataForNextPage(pageNo,objectList){
    this.LOCAL_DB[pageNo] = objectList;
  }

  spliceAndSaveDataInLocalDB(objectList){
    if(objectList.length == 0) return
    let pageNo = Object.keys(this.LOCAL_DB).length;
    let latestPageNo = pageNo == 0 ? 0 : pageNo - 1;
    let pageData = [];
    if(objectList.length == 0){
      this.LOCAL_DB[pageNo] = [];
    }
    
    if(this.LOCAL_DB[latestPageNo] != 'viewed' && this.LOCAL_DB[latestPageNo] && this.LOCAL_DB[latestPageNo].length != 0 && this.LOCAL_DB[latestPageNo].length < ENV_CONFIG["constants"]["PAGE_LIMIT"]){
      let endIndex = objectList.length;
      pageNo = latestPageNo;
      pageData.push(this.LOCAL_DB[latestPageNo])
      endIndex = ENV_CONFIG["constants"]["PAGE_LIMIT"] - this.LOCAL_DB[latestPageNo].length;
      pageData[0] = pageData[0].concat(objectList.slice(0,endIndex));
      objectList = objectList.slice(endIndex);
    }
    for(let i = 0 ; i < objectList.length ; i++){
      pageData.push(objectList.slice(i, i + ENV_CONFIG["constants"]["PAGE_LIMIT"]))
      i += ENV_CONFIG["constants"]["PAGE_LIMIT"] - 1;
    }
    pageData.map(page=>{
      this.LOCAL_DB[pageNo] = page;
      pageNo ++;
    })
    console.log("LOCAL_DB DATA AFTER RENDERING",this.LOCAL_DB);
  }


  deleteLocalBufferOnceThePageIsViewed(pageNo){
    if(this.LOCAL_DB[pageNo]){
      this.LOCAL_DB[pageNo] = "viewed";
      console.log("LOCAL_DB for rendered data",this.LOCAL_DB);
    }
  }

  checkIfBufferDataIsPresent(){
    let keys = Object.values(this.LOCAL_DB);
    let bufferDataPresent = keys.some(obj=> {
      return obj != "viewed"; 
    })
    return bufferDataPresent;
  }
}
